import PropTypes from 'prop-types';

/**
 * For the description of each attribute
 * Check form_definition.py
 */

const AddressSubFieldPropType = {
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  display: PropTypes.bool,
  placeholder: PropTypes.string,
};

export const InventoryProductPropType = {
  stock_quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variants: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  is_quantity_changed: PropTypes.bool,
  payment_currency: PropTypes.string,
  product_title: PropTypes.string,
  stock_option: PropTypes.string,
  inventory_id: PropTypes.number,
  description: PropTypes.string,
  enable_stock: PropTypes.bool,
  selection: PropTypes.object,
  quantity: PropTypes.number,
  category: PropTypes.array,
  image: PropTypes.string,
  price: PropTypes.number,
  form: PropTypes.string,
  id: PropTypes.number,
};

export const ControlPropProptype = {
  inventory_products: PropTypes.arrayOf(PropTypes.shape(InventoryProductPropType)),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  subtext: PropTypes.string,
  required: PropTypes.bool,
  prepended_text: PropTypes.string,
  text_alignment: PropTypes.string,
  table_width: PropTypes.number,
  appended_text: PropTypes.string,
  type: PropTypes.number,
  options: PropTypes.arrayOf(PropTypes.string),
  images: PropTypes.arrayOf(PropTypes.string),
  image_size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string,
  amount: PropTypes.number,
  currency: PropTypes.string,
  country: PropTypes.string,
  popup_title: PropTypes.string,
  sub_unit: PropTypes.number,
  popup_description: PropTypes.string,
  payment_logo: PropTypes.string,
  pay_button_text: PropTypes.string,
  user_specify: PropTypes.bool,
  min_length: PropTypes.number,
  max_length: PropTypes.number,
  min_date: PropTypes.string,
  max_date: PropTypes.string,
  min_time: PropTypes.string,
  max_time: PropTypes.string,
  disabled_days: PropTypes.arrayOf(PropTypes.string),
  disabled_dates: PropTypes.arrayOf(PropTypes.string),
  disabled_date_range: PropTypes.string,
  time_format: PropTypes.oneOf(['', '24', '12']),
  separator: PropTypes.oneOf(['', '/', '-', '.']),
  mode: PropTypes.oneOf(['', 'single', 'multiple', 'range']),
  date_format: PropTypes.oneOf(['', 'MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD']),
  past: PropTypes.bool,
  future: PropTypes.bool,
  max_selections: PropTypes.number,
  min_selections: PropTypes.number,
  min_word_length: PropTypes.number,
  max_word_length: PropTypes.number,
  phone_default_code: PropTypes.string,
  phone_codes_limit: PropTypes.bool,
  phone_valid_codes: PropTypes.arrayOf(PropTypes.string),
  url: PropTypes.string,
  image_url: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  divider: PropTypes.bool,
  left: PropTypes.bool,
  right: PropTypes.bool,
  inline: PropTypes.bool,
  show_labels: PropTypes.bool,
  placement: PropTypes.string,
  upload_image: PropTypes.string,
  file_field_id: PropTypes.string,
  max_rows: PropTypes.number,
  min_rows: PropTypes.number,
  stacked: PropTypes.bool,
  unstackable: PropTypes.bool,
  no_table_border: PropTypes.bool,
  max_file_size: PropTypes.number,
  file_categories: PropTypes.oneOfType([
    PropTypes.oneOf(['IMAGES', 'VIDEOS', 'DOCUMENTS']),
    PropTypes.arrayOf(PropTypes.string)
  ]),
  file_extensions: PropTypes.arrayOf(PropTypes.string),
  stars_count: PropTypes.number,
  scale_count: PropTypes.number,
  hearts_count: PropTypes.number,
  columns: PropTypes.number,
  row_headers: PropTypes.arrayOf(PropTypes.string),
  column_headers: PropTypes.arrayOf(PropTypes.string),
  column_types: PropTypes.arrayOf(PropTypes.string),
  column_widths: PropTypes.arrayOf(PropTypes.number),
  rating_type: PropTypes.oneOf(['radio', 'star', 'checkbox']),
  other: PropTypes.shape({
    enabled: PropTypes.bool,
    label: PropTypes.string,
  }),
  rename: PropTypes.shape({
    enabled: PropTypes.bool,
    internal_id: PropTypes.string,
  }),
  controls: PropTypes.arrayOf(PropTypes.string),
  sort_options: PropTypes.bool,
  shuffle_options: PropTypes.bool,
  hidden: PropTypes.bool,
  operation: PropTypes.string,
  default: PropTypes.string,
  now: PropTypes.bool,
  unit: PropTypes.string,
  column_calculation: PropTypes.number,
  weights: PropTypes.arrayOf(PropTypes.number),
  option_values: PropTypes.bool,
  readonly: PropTypes.bool,
  lookup_type: PropTypes.number,
  field_type: PropTypes.string,
  form: PropTypes.string,
  form_field: PropTypes.string,
  source_field_ids: PropTypes.arrayOf(PropTypes.string),
  dest_field_ids: PropTypes.arrayOf(PropTypes.string),
  sort: PropTypes.oneOf(['', 'ascending', 'descending']),
  list_products: PropTypes.bool,
  shown_product: PropTypes.string,
  billing_address: PropTypes.bool,
  save_card_stripe: PropTypes.bool,
  street_address_line_1: PropTypes.shape(AddressSubFieldPropType),
  street_address_line_2: PropTypes.shape(AddressSubFieldPropType),
  postal_code: PropTypes.shape(AddressSubFieldPropType),
  city: PropTypes.shape(AddressSubFieldPropType),
  state: PropTypes.shape(AddressSubFieldPropType),
  address_country: PropTypes.shape(AddressSubFieldPropType),
  metadata: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  modal_pay_button: PropTypes.string,
  deleted_inventory_product_ids: PropTypes.array,
  accept_inventory_payment: PropTypes.bool,
  inventory_payment_type: PropTypes.string,
  is_inventory_payment: PropTypes.bool,
  enable_answer_piping: PropTypes.bool,
  piped_label: PropTypes.string
};

export const ControlPropType = {
  type: PropTypes.string.isRequired,
  internal_id: PropTypes.string.isRequired,
  display_id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.array),
    PropTypes.object,
  ]), // this might need to be updated for table fields
  is_row: PropTypes.bool,
  props: PropTypes.shape(ControlPropProptype),
  table_props: PropTypes.arrayOf(PropTypes.shape(ControlPropProptype)),
  formatedValue: PropTypes.string,

  _validationError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.array),
  ]), // this might need to be further updated to fit proper proptype
  _name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  _invalid: PropTypes.bool,
};

export const formDesignProps = {
  old: PropTypes.shape({
    layout_class: PropTypes.string.isRequired,
    submission_button_text: PropTypes.string.isRequired,
    save_continue_button_text: PropTypes.string.isRequired,
    previous_button_text: PropTypes.string.isRequired,
    next_button_text: PropTypes.string.isRequired,
    submission_button_background: PropTypes.string.isRequired,
    submission_button_position: PropTypes.string.isRequired,
    multipage_buttons_position: PropTypes.string.isRequired,
    submission_button_type: PropTypes.string.isRequired,
    page_background: PropTypes.string.isRequired,
    form_text_color: PropTypes.string.isRequired,
    form_font: PropTypes.string.isRequired,
    form_font_size: PropTypes.string.isRequired,
    form_title_font_size: PropTypes.string.isRequired,
    form_external_css: PropTypes.string.isRequired,
    form_background_image: PropTypes.string.isRequired,
    custom_form_width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    background_image_size: PropTypes.string.isRequired,
    background_image_fixed: PropTypes.bool.isRequired,
    background_image_repeat: PropTypes.bool.isRequired,
    underline_title: PropTypes.bool.isRequired,
  }).isRequired,
  design: PropTypes.shape({
    button_border_radius: PropTypes.number.isRequired,
    button_text_color: PropTypes.string.isRequired,
    custom_form_width: PropTypes.number.isRequired,
    footer_alignment: PropTypes.string.isRequired,
    footer_background_color: PropTypes.string.isRequired,
    footer_color: PropTypes.string.isRequired,
    footer_padding: PropTypes.number.isRequired,
    form_background: PropTypes.string.isRequired,
    form_background_image: PropTypes.string.isRequired,
    form_background_image_fixed: PropTypes.bool.isRequired,
    form_background_image_repeat: PropTypes.bool.isRequired,
    form_background_image_size: PropTypes.string.isRequired,
    form_background_transparency: PropTypes.number.isRequired,
    form_background_type: PropTypes.string.isRequired,
    form_body_label_color: PropTypes.string.isRequired,
    form_body_label_transform: PropTypes.string.isRequired,
    form_body_padding: PropTypes.number.isRequired,
    form_border_radius: PropTypes.number.isRequired,
    form_direction: PropTypes.string.isRequired,
    form_field_background_color: PropTypes.string.isRequired,
    form_field_border_color: PropTypes.string.isRequired,
    form_field_border_radius: PropTypes.number.isRequired,
    form_field_color: PropTypes.string.isRequired,
    form_gradient_direction: PropTypes.string.isRequired,
    form_gradient_end_color: PropTypes.string.isRequired,
    form_gradient_shape: PropTypes.string.isRequired,
    form_gradient_start_color: PropTypes.string.isRequired,
    form_gradient_type: PropTypes.string.isRequired,
    form_layout: PropTypes.string.isRequired,
    label_orientation: PropTypes.string.isRequired,
    logo_placement: PropTypes.string.isRequired,
    page_background_blur: PropTypes.string.isRequired,
    page_background_type: PropTypes.string.isRequired,
    page_gradient_direction: PropTypes.string.isRequired,
    page_gradient_end_color: PropTypes.string.isRequired,
    page_gradient_shape: PropTypes.string.isRequired,
    page_gradient_start_color: PropTypes.string.isRequired,
    page_gradient_type: PropTypes.string.isRequired,
    secondary_button_background_color: PropTypes.string.isRequired,
    secondary_button_color: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,
  }).isRequired,
};

export default { ControlPropType, formDesignProps, InventoryProductPropType };
